import { HTTP, HTTP_CONFIG } from '../http';

const BASE_SUPPORT_API = 'index.php?api=SupportAdmin';
export default {
  search(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/searchUsers', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=searchUsers`, params)
      .then(response => response.data);
  },
  deleteBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/deleteSafeboxDuplicate', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=deleteSafeboxDuplicate`, params)
      .then(response => response.data);
  },
  deleteRGPDBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/destroyWithRGPD', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=destroyWithRGPD`, params)
      .then(response => response.data);
  },
  updateEmailBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/updateEmail', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=updateEmail`, params)
      .then(response => response.data);
  },
  updateLoginBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/updateLogin', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=updateLogin`, params)
      .then(response => response.data);
  },
  updateSecretQuestionBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/updateSecretQuestion', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=updateSecretQuestion`, params)
      .then(response => response.data);
  },
  updateGenderBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/updatePersonalInfos', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=updatePersonalInfos`, params)
      .then(response => response.data);
  },
  updateDematStatus(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/updateBpeStatus', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=updateBPEStatus`, params)
      .then(response => response.data);
  },
  addEfoliaId(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/addEfoliaId', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=addEfoliaId`, params)
      .then(response => response.data);
  },
  updateFirstnameLastname(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/updatePersonalInfos', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=updatePersonalInfos`, params)
      .then(response => response.data);
  },
  unlockBoxe(params) {
    if (HTTP_CONFIG.backOfficeVersion === HTTP_CONFIG.BACKOFFICE_V2) {
      return HTTP.post('/SupportAdmin/unlockAccount', params)
        .then(response => response.data);
    }
    return HTTP.post(`${BASE_SUPPORT_API}&a=unlockAccount`, params)
      .then(response => response.data);
  },
};
